import { ProductRepository } from "../Repository/ProductRepository";



    export interface DeleteProductGalleryUseCase {
        invoke: (id: number) => Promise<boolean>;
    }
  
    export class DeleteProductGallery implements DeleteProductGalleryUseCase {
            private productRepo: ProductRepository;
            constructor(_ProductRepo: ProductRepository) {
            this.productRepo = _ProductRepo;
        }
        async invoke(id: number) {
            if(!id){
                throw new Error("Your todo should have at leat 2 characters.");
            }
            const update  = await this.productRepo.deleteProductGallery(id);
            return update;
        }
    }